import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { FunctionField, Show, SimpleShowLayout } from "react-admin";
import StudentsInfo from "./StudentsInfo";
import ScheduleInfo from "./ScheduleInfo";
import SlotsInfo from "./SlotsInfo";
import { SectionTitle } from "features/SectionTitle";

const ShowScheduleIndividualCycle = () => {
  return (
    <Show
      title="Детайли на индивидуално циклично разписание"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <ScheduleInfo />

        <SectionTitle
          title="Часови интервали"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <SlotsInfo />
        <SectionTitle
          title="Студенти"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <FunctionField render={rec => <StudentsInfo slotsChoices={rec?.slots} />} />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowScheduleIndividualCycle;
